import { FunctionComponent, useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { videoMap, learnMoreMap, LocaleTypes } from '@/config/whole-home-backup-power-solution';
import EFArrowRight from '@/components/UI/svg/Icons/EFArrowRight';
import EFPic from '@/components/UI/EFPic';
import EFVideoModal from '@/components/UI/EFVideoModal';

const UsersVideos: FunctionComponent = () => {
    const { useLang, useRouter, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('landingPage');
    const videoList: any = videoMap[locale as LocaleTypes] || videoMap.us;
    const learnMoreList: any = learnMoreMap[locale as LocaleTypes] || learnMoreMap.ca;
    const openhandle = (item: any) => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'solution_button',
                list_name: t(item.title),
                button_name: t('learn_more'),
            });
            // fb埋点
            // window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
        item?.link && window.open(item?.link);
    };
    const [videoSource, setVideoSource] = useState('');
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    return (
        <section className={`${css.UsersVideos} UsersVideos`}>
            <div className="video-wrapper">
                {locale !== 'sa' && (
                    <>
                        <div className="title">{t('secO_title_h5')}</div>
                        <div className="desc">{t('secO_desc_h5')}</div>
                        <div className="video-list">
                            {videoList.map((item: any, index: number) => (
                                <div
                                    className="video"
                                    key={index}
                                    onClick={() => {
                                        try {
                                            // GA埋点
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'video',
                                                title_name: t(item.desc),
                                                position: `Solution Page_${index + 1}`,
                                            });
                                            // fb埋点
                                            // window?.fbq && window?.fbq('track', 'Search');
                                        } catch (e) {
                                            console.log(e);
                                        }
                                        setVideoSource(item.source);
                                        setShowEFVideoModal(true);
                                    }}
                                >
                                    <div className="img-box">
                                        <EFPic src={item.poster} className="video-img" />
                                        <div className="mask"></div>
                                    </div>
                                    <div className="video-desc">{t(item.desc)}</div>
                                    <div className="play-icon"></div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
                <div className="learn-more-wrapper">
                    {learnMoreList.map((item: any, index: number) => (
                        <div className="learn-more-item" key={index}>
                            <div className="title">{t(item.title)}</div>
                            <div className="desc">{t(item.desc)}</div>
                            <div className="learn-more">
                                <span onClick={() => openhandle(item)}>{t('learn_more')}</span>
                                <EFArrowRight height="0.16rem" width="0.16rem" color="#2673ff" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {videoSource && showEFVideoModal && (
                <EFVideoModal
                    visible={showEFVideoModal}
                    source={videoSource}
                    onClose={() => setShowEFVideoModal(false)}
                    playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
                />
            )}
        </section>
    );
};

export default UsersVideos;
